
import { AestheticStyle, StudioSettings } from '../types';

export const DEFAULT_STUDIO_SETTINGS: Record<AestheticStyle, StudioSettings> = {
  [AestheticStyle.STUDIO_MINIMAL]: {
    lighting: { intensity: 'soft', temperature: 'neutral' },
    background: { texture: 'seamless paper', color: 'pure white' },
    camera: { angle: 'front', depthOfField: 'medium' },
    props: ''
  },
  [AestheticStyle.DARK_LUXURY]: {
    lighting: { intensity: 'dramatic', temperature: 'cool' },
    background: { texture: 'black velvet', color: 'black' },
    camera: { angle: 'low-angle', depthOfField: 'deep' },
    props: ''
  },
  [AestheticStyle.GOLDEN_HOUR]: {
    lighting: { intensity: 'soft', temperature: 'warm' },
    background: { texture: 'sunset window', color: 'golden' },
    camera: { angle: 'isometric', depthOfField: 'shallow' },
    props: 'shadow patterns'
  },
  [AestheticStyle.ETHEREAL_DREAM]: {
    lighting: { intensity: 'soft', temperature: 'neutral' },
    background: { texture: 'silk cloth', color: 'pastel pink' },
    camera: { angle: 'macro', depthOfField: 'shallow' },
    props: 'flowers'
  },
  [AestheticStyle.ARCHITECTURAL]: {
    lighting: { intensity: 'hard', temperature: 'cool' },
    background: { texture: 'concrete', color: 'grey' },
    camera: { angle: 'top-down', depthOfField: 'deep' },
    props: 'geometric blocks'
  },
  [AestheticStyle.ORGANIC_NATURE]: {
    lighting: { intensity: 'medium', temperature: 'warm' },
    background: { texture: 'natural stone', color: 'earth tones' },
    camera: { angle: 'isometric', depthOfField: 'medium' },
    props: 'wood, leaves'
  },
  [AestheticStyle.UGC_SOCIAL]: {
    lighting: { intensity: 'medium', temperature: 'neutral' },
    background: { texture: 'cafe table', color: 'beige' },
    camera: { angle: 'top-down', depthOfField: 'medium' },
    props: 'coffee cup'
  },
  [AestheticStyle.LIFE_SHOWCASE]: {
    lighting: { intensity: 'soft', temperature: 'warm' },
    background: { texture: 'marble vanity', color: 'white' },
    camera: { angle: 'isometric', depthOfField: 'medium' },
    props: 'perfume bottle'
  },
  [AestheticStyle.ON_MODEL]: {
    lighting: { intensity: 'soft', temperature: 'warm' },
    background: { texture: 'skin', color: 'natural' },
    camera: { angle: 'front', depthOfField: 'shallow' },
    props: ''
  }
};
